import styled from 'styled-components';

import { Modal } from '../../../Modal';

export const Container = styled(Modal.Content)`
  padding: 0;
`;
